import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { StyledTextField, Wrapper } from '../../RenameModal/RenameModal.style';
import { CloseIconWrapper, SubmitButtonsWrapper } from 'components/Dialogs/SaveModal/SaveModal.style';
import { ReactComponent as CloseIcon } from 'assets/icons/closeIcon.svg';
import { ModalProps } from 'components/Dialogs/types';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setUserFilenameAction } from 'store/features/pages/actions';
import { selectPageById } from 'store/features/pages/selectors';
import { setNewFilename } from 'store/features/newFiles/newFilesSlice';
import { removeFileExtension } from 'helpers';
import { createNewFiles } from 'store/features/newFiles/actions';
import { useFormik } from 'formik';
import { validationFilenameSchema } from 'components/Dialogs/RenameModal/RenameModal';

const RenameFileModal = ({ toggleModalOpen, actualPageId }: ModalProps) => {
    const page = useAppSelector(selectPageById(actualPageId));

    const dispatch = useAppDispatch();

    const formik = useFormik({
        initialValues: {
            filename: removeFileExtension(page.userFileName ?? page.fileName.new ?? page.fileName.old)
        },
        validationSchema: validationFilenameSchema,
        onSubmit: values => {
            dispatch(
                setUserFilenameAction({ id: actualPageId, changes: { userFileName: `${values.filename?.trim()}.pdf` } })
            );
            dispatch(setNewFilename({ id: actualPageId, changes: { filename: `${values.filename?.trim()}.pdf` } }));
            dispatch(createNewFiles());
            toggleModalOpen('save');
        }
    });

    return (
        <Wrapper>
            <h1>Zmień nazwę pliku</h1>
            <Box component='form' noValidate autoComplete='off' onSubmit={formik.handleSubmit}>
                <StyledTextField
                    id='filename'
                    name='filename'
                    label='Nazwa pliku'
                    variant='outlined'
                    value={formik.values.filename}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.filename && Boolean(formik.errors.filename)}
                    helperText={formik.touched.filename && formik.errors.filename}
                />
                <SubmitButtonsWrapper style={{ marginTop: '18px' }}>
                    <Button variant='text' onClick={() => toggleModalOpen('save')}>
                        Wróć
                    </Button>
                    <Button variant='contained' type='submit'>
                        Zapisz
                    </Button>
                </SubmitButtonsWrapper>
            </Box>
            <CloseIconWrapper>
                <CloseIcon onClick={() => toggleModalOpen('save')} />
            </CloseIconWrapper>
        </Wrapper>
    );
};

export default RenameFileModal;
